import React from 'react';

export const ReportSkeleton = () => {
  return (
    <div className="h-full w-full p-6 bg-white">
      {/* Largest header bar at the top */}
      <div className="mb-8">
        <div className="h-12 bg-gray-200 rounded w-full animate-pulse"></div>
      </div>

      {/* Controls section */}
      <div className="flex justify-end mb-8 pb-4 border-b border-gray-100">
        <div className="flex space-x-3">
          <div className="h-8 bg-gray-200 rounded w-24 animate-pulse"></div>
          <div className="h-8 bg-gray-200 rounded w-28 animate-pulse"></div>
          <div className="h-8 bg-gray-200 rounded w-24 animate-pulse"></div>
        </div>
      </div>

      {/* Document Title */}
      <div className="mb-8">
        <div className="h-6 bg-gray-300 rounded w-80 animate-pulse"></div>
      </div>

      {/* Main Content Area - Uniform rectangles aligned left */}
      <div className="space-y-4">
        {/* First paragraph */}
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>

        {/* Paragraph break */}
        <div className="h-2"></div>
        
        {/* Second paragraph */}
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
        
        {/* Paragraph break */}
        <div className="h-2"></div>
        
        {/* Third paragraph */}
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-4/5 animate-pulse"></div>
        
        {/* Paragraph break */}
        <div className="h-2"></div>
        
        {/* Fourth paragraph (shorter) */}
        <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
      </div>
    </div>
  );
};